import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  action: {
    defaultMessage: 'ACTION',
    id: `app.containers.WorkflowEditor.components.Rules.DocumentSigningRules.TemplateSettings.action`,
  },
});
